var Phone = /** @class */ (function () {
    function Phone(rawPhone) {
        this.id = '';
        this.phoneNumber = '';
        this.preferred = false;
        if (!rawPhone)
            return;
        var id = rawPhone.id, phoneNumber = rawPhone.phoneNumber, preferred = rawPhone.preferred;
        this.id = id;
        this.phoneNumber = phoneNumber !== null && phoneNumber !== void 0 ? phoneNumber : '';
        this.preferred = preferred !== null && preferred !== void 0 ? preferred : false;
    }
    return Phone;
}());
export default Phone;
//# sourceMappingURL=Phone.js.map